import { render, staticRenderFns } from "./Cotizacion.vue?vue&type=template&id=72b28d63&scoped=true&"
import script from "./Cotizacion.vue?vue&type=script&lang=js&"
export * from "./Cotizacion.vue?vue&type=script&lang=js&"
import style0 from "./Cotizacion.vue?vue&type=style&index=0&id=72b28d63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b28d63",
  null
  
)

export default component.exports